<template>
  <div class="card mb-4">
    <div class="card-header">
      <div class="row">
        <div class="col-6 d-flex align-items-center">
          <h6 class="mb-0">Sub Kategori Produk</h6>
        </div>
        <div class="col-6 text-end">
          <soft-button
            color="success"
            size="sm"
            variant="outline"
            @click="openModalCreate()"
            >Tambah Baru</soft-button
          >
        </div>
      </div>
    </div>
    <div class="card-body p-0 w-100">
      <div class="table-responsive p-0">
        <good-table-sub-categories
          v-bind:sub-categories="this.dataProductSubCategories"
        >
        </good-table-sub-categories>
      </div>
    </div>
  </div>
  <modal
    :show="modal.status"
    body-classes="p-0"
    modal-classes="modal-dialog-centered modal-md"
  >
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-6 d-flex align-items-center">
                <h6 class="mb-0">{{ modal.title }}</h6>
              </div>
              <div class="col-6 text-end">
                <span class="cursor-pointer" @click="this.modal.status = false"
                  >x</span
                >
              </div>
            </div>
          </div>
          <div class="card-body p-3 pb-0 mb-0">
            <div class="mb-4 text-danger" v-for="error in errors" :key="error">
              <div v-if="!!error.forEach">
                <p class="mb-0" v-for="message in error" :key="message">
                  {{ message }}
                </p>
              </div>
            </div>
            <form
              ref="form"
              action="#"
              :method="modal.method"
              role="form"
              class="row"
              v-on:submit.prevent="submit(modal.method)"
            >
              <div class="col-12">
                <div class="form-group">
                  <label class="form-label">Kategori Produk</label>
                  <select
                    class="form-select"
                    aria-label="Kategori produk"
                    v-model="subCategory.product_category_id"
                  >
                    <option value="" selected>Pilih kategori produk</option>
                    <option
                      :value="category.id"
                      v-for="category in productCategories"
                      :key="category.id"
                    >
                      {{ category.name }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="form-label">Nama Sub Kategori</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Nama Kategori"
                    v-model="subCategory.name"
                  />
                </div>
                <div class="my-3">
                  <soft-button color="success" size="sm" variant="outline">{{
                    modal.button
                  }}</soft-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import axios from "axios";
import SoftButton from "@/components/SoftButton.vue";
import Modal from "@/views/components/Modal.vue";
import { sweatalert } from "@/reactivities/sweatalert.js";
import GoodTableSubCategories from "./GoodTableSubCategories.vue";

export default {
  props: ["productCategories", "productSubCategories"],
  name: "table-sub-categories",
  components: {
    SoftButton,
    Modal,
    GoodTableSubCategories,
  },
  data() {
    return {
      dataProductSubCategories: this.productSubCategories,
      listCategories: null,
      urlSubCategory: `${this.apiUrl}/product/sub-category`,
      modal: {
        status: false,
        method: "POST", // default
        title: "",
        button: "Tambah Baru", // default
        methodFuction: "tambahSubCategory",
      },
      subCategory: {
        id: "",
        product_category_id: "",
        name: "",
      },
      authToken:
        "Bearer " + JSON.parse(localStorage.getItem("user")).accessToken,
      errors: null,
    };
  },
  updated() {
    if (this.dataProductSubCategories.length == 0) {
      this.dataProductSubCategories = this.productSubCategories;
    }
  },
  methods: {
    submit(method) {
      if (method == "POST") {
        this.tambahSubCategory();
      } else if (method == "PUT") {
        this.editSubCategory();
      }
    },
    openModalCreate() {
      this.errors = "";

      this.modal.status = true;
      this.modal.method = "POST";
      this.modal.methodFuction = "tambahSubCategory";
      this.modal.title = "Tambah Sub Kategori";
      this.subCategory.name = "";
    },
    openModalEdit(subCategoryId) {
      this.errors = "";

      const selectedCategory = this.productSubCategories.find(
        (subCategory) => subCategory.id === subCategoryId
      );

      this.modal.status = true;
      this.modal.method = "PUT";
      this.modal.methodFuction = "updateCategory";
      this.modal.title = "Edit Kategori";
      this.modal.button = "Simpan";
      this.subCategory.id = selectedCategory.id;
      this.subCategory.product_category_id =
        selectedCategory.product_category_id;
      this.subCategory.name = selectedCategory.name;
    },
    closeModal() {
      this.modal.status = false;
    },
    appendSubCategory(dataCategory) {
      this.dataProductSubCategories.push(dataCategory);
    },
    tambahSubCategory: function () {
      axios
        .post(this.urlSubCategory, this.subCategory, {
          headers: { Authorization: this.authToken },
        })
        .then((response) => {
          this.appendSubCategory(response.data.data);

          sweatalert.showAlert("success", response.data.message);
          this.closeModal();
        })
        .catch((error) => {
          this.errors = error.response.data.errors;

          Object.keys(this.errors).forEach((key) => {
            sweatalert.showAlert("error", this.errors[key]);
          });
        });
    },
    editSubCategory: function () {
      axios
        .put(
          this.urlSubCategory + "/" + this.subCategory.id,
          this.subCategory,
          {
            headers: { Authorization: this.authToken },
          }
        )
        .then((response) => {
          var _this = this;

          _this.dataProductSubCategories.map(function (category, index) {
            if (category.id == response.data.data.id) {
              _this.dataProductSubCategories[index] = {
                id: response.data.data.id,
                product_category_id: response.data.data.product_category_id,
                category: response.data.data.category,
                name: response.data.data.name,
              };
            }

            return category;
          });
          sweatalert.showAlert("success", response.data.message);
          this.closeModal();
        })
        .catch((error) => {
          this.errors = error.response.data.errors;

          Object.keys(this.errors).forEach((key) => {
            sweatalert.showAlert("error", this.errors[key]);
          });
        });
    },
    deleteSubCategory: function (subCategoryId) {
      if (
        confirm(
          "Anda yakin ingin menghapus sub kategori ini? Ini tidak dapat dibatalkan."
        )
      ) {
        axios
          .delete(this.urlSubCategory + "/" + subCategoryId, {
            headers: { Authorization: this.authToken },
          })
          .then(
            (response) => {
              this.dataProductSubCategories = this.dataProductSubCategories.filter(
                (category) => category.id !== subCategoryId
              );
              console.log(this.dataProductSubCategories);
              sweatalert.showAlert("success", response.data.message);
            },
            (err) => {
              console.log(err.response);
            }
          )
          .catch((error) => {
            this.errors = error.response.data.errors;

            Object.keys(this.errors).forEach((key) => {
              sweatalert.showAlert("error", this.errors[key]);
            });
          });
      }
    },
  },
};
</script>
